import type { StandardWidgetDataConfig } from "@/components/dashboard/widget-config";

/** Deep-link into the alert rule builder with widget telemetry binding prefilled. */
export function buildCreateAlertFromWidgetHref(cfg: StandardWidgetDataConfig): string {
  const p = new URLSearchParams();
  p.set("device_id", cfg.device_id);
  p.set("aggregation", cfg.aggregation);
  p.set("time_range", cfg.time_range);
  if (cfg.channel) {
    p.set("channel", cfg.channel);
  }
  if (cfg.formula) {
    p.set("formula", cfg.formula);
  }
  if (cfg.metric_id) {
    p.set("metric_id", cfg.metric_id);
  }
  p.set("batch", "1");
  return `/alerts/rules/new?${p.toString()}`;
}
